
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/office-space/[...slug]",
      function () {
        return require("private-next-pages/office-space/[...slug].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/office-space/[...slug]"])
      });
    }
  